import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const Loader = ({ text = "Loading..." }) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: 3,
                gap: 2,
                animation: "fadeIn 0.4s ease-in-out",
            }}
        >
            <CircularProgress size={40} />
            <Typography variant="subtitle1" sx={{ opacity: 0.8 }}>
                {text}
            </Typography>

            {/* CSS animation */}
            <style>
                {`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(4px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                `}
            </style>
        </Box>
    );
};

export default Loader;
